import { useEffect, useState } from "react";
import { Info } from "lucide-react";
import { useAuthedApi } from "../../lib/api";

export default function AdminUsers() {
  const api = useAuthedApi();
  const [users, setUsers] = useState(null);
  useEffect(() => { api("get", "/admin/users").then(setUsers); }, [api]);

  return (
    <div className="space-y-5" data-testid="admin-users">
      <div className="lux-card p-5 flex gap-3 text-sm text-gray-300" data-testid="admin-users-block-note">
        <Info className="w-5 h-5 text-[#D4AF37] shrink-0" />
        <p>To <strong>block or delete a user account</strong>, open <strong>Manage → Users &amp; Auth</strong> in your Emergent workspace (Preview or Live tab) — blocked people can no longer sign in. To hide a dealer's store and cars instantly, use <strong>Block</strong> in the Dealers tab; to remove a single car, use the Listings tab.</p>
      </div>
      <div className="lux-card overflow-x-auto">
        <table className="w-full text-sm min-w-[700px]">
          <thead><tr className="text-left text-[10px] uppercase tracking-widest text-gray-500 border-b border-white/5">
            <th className="p-4">Name</th><th>Email</th><th>Role</th><th>Listings</th><th>Dealer store</th><th className="p-4">Joined</th>
          </tr></thead>
          <tbody>
            {users?.map((u) => (
              <tr key={u.user_id} className="border-b border-white/5" data-testid={`admin-user-row-${u.user_id}`}>
                <td className="p-4">{u.name || "—"}</td>
                <td className="text-gray-400">{u.email || "—"}</td>
                <td><span className={u.role === "admin" ? "gold-text font-semibold" : "text-gray-400"}>{u.role}</span></td>
                <td>{u.listings}</td>
                <td className="text-gray-400">{u.store || "—"}</td>
                <td className="p-4 text-xs text-gray-500">{u.created_at ? new Date(u.created_at).toLocaleDateString("en-IN") : "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {users && !users.length && <p className="p-10 text-center text-gray-400">No users yet.</p>}
      </div>
    </div>
  );
}
